import React from 'react';
import styles from './layout.module.css';

const Layout=(props)=>{
	let elemsToRender=props.children.slice(props.increment || 0, (props.increment || 0)+3);
	return (
		<div className={`${styles['outer-container']} ${props.hide_content?styles.hidden:''}`}>
			{elemsToRender.map((e, i) => {
				return (<div key={i} className={styles['content-wrap']}>{e}</div>)
			})}
		</div>
	);
}

export default Layout;
